import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function heroImageFunction() {
	if($(".wp-block-thefuturblocks-hero-image.has-anim").length) {
		$(".wp-block-thefuturblocks-hero-image.has-anim").each(function() {
			const self = $(this),
				image = self.find(".wp-block-thefuturblocks-hero-image__image").eq(0),
				tl = gsap.timeline();
			let posS, posE;

			tl.to(image, {duration: 1, yPercent:-16.6, ease:"none"});

		    if(image.hasClass("parallax-top")) {
		    	posS = 'top +=120';
		    	posE = 'bottom +=120';
		   	} else {
		   		posS = 'top center';
		    	posE = 'bottom center';
		   	}
			const st = ScrollTrigger.create({
				trigger: self,
				start: "+=160 bottom",
				end: "+=160 top",
				scrub: 0.5,
    			toggleActions: "play reverse play reverse",
				animation: tl
			});
		    
		});
	}
}

heroImageFunction();